import { Outlet } from "react-router-dom";
import { adminPaymentsRoutes } from "../Payments/payments-routes";
import { adminUnpaidClientsRoutes } from "../UnpaidClients/unpaid-clients-routes";
import BookingList from "./BookingList";
import BookingForm from "./BookingForm";
import BookingDetails from "./BookingDetails";


export const adminBookingRoutes = [
  {
    path: "bookings",
    element: Outlet,
    children: [
      {
        path: '',
        redirect: 'list'
      },
      {
        path: "list",
        element: BookingList,
      },
      {
        path: "add",
        element: BookingForm,
      },
      {
        path: "edit/:id",
        element: BookingForm,
      },
      {
        path: "view/:id",
        element: BookingDetails,
      },
      ...adminPaymentsRoutes,
      ...adminUnpaidClientsRoutes
    ],
  },
];
